import { JackpotDisplayDiamondPot } from "./JackpotDisplayDiamondPot";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";

export class JackpotDisplayJubilee extends JackpotDisplayDiamondPot 
{

    public constructor(params: JackpotDisplayParams) {
        super(params);

    }


    public override TitlePrepare(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new SpriteResource(this.jackpot+ "jackpot_anims/Jubilee/jubileetitle", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

    
	public override TitleHide(){
		this.titleSpriteAnim.Hide();
	}
}